import user1 from './assets/userm-1.jpg';
import user2 from './assets/userf-2.jpg';
import user3 from './assets/userm-3.jpg';
import user4 from './assets/userf-4.jpg';
import user5 from './assets/userm-5.jpg';
const users = [
    {
        id: 1,
        nome: 'Marcio',
        sobrenome: 'Rodrigues',
        email: 'marcio.coelho@fatec.sp.gov.br',
        preferidos: 25,
        seguidores: 72,
        userImg: user1
    },
    {
        id: 2,
        nome: 'Ana',
        sobrenome: 'Beatriz',
        email: 'anabeatriz14322@gmail.com',
        preferidos: 6,
        seguidores: 20,
        userImg: user2
    },
    {
        id: 3,
        nome: 'Pedro',
        sobrenome: 'Tavares',
        email: 'ehotaldotavares@bol.com.br',
        preferidos: 80,
        seguidores: 1,
        userImg: user3
    },
    {
        id: 4,
        nome: 'Elaine',
        sobrenome: 'Andrade',
        email: 'contato@draelaine.com',
        preferidos: 10,
        seguidores: 85,
        userImg: user4
    },
    {
        id: 5,
        nome: 'Hamilton',
        sobrenome: 'Romeu Pinto',
        email: 'hromeupinto@gmail.com',
        preferidos: 69,
        seguidores: 66,
        userImg: user5
    }
]

export default users